import classNames from 'classnames';
import * as React from 'react';
import { PinProps } from './pin_low_activity';

export const PinHighActivitySelected = (props: PinProps) => {
  const { onClick, favorite, className, hasSurveyData, lunkerPotential } = props;

  let fill = '#FF2A00';
  let icon = (
    <>
      <path
        d="M71.0187 88.3885C84.614 88.3885 95.6352 77.4115 95.6352 63.8706C95.6352 50.3298 84.614 39.3528 71.0187 39.3528C57.4235 39.3528 46.4023 50.3298 46.4023 63.8706C46.4023 77.4115 57.4235 88.3885 71.0187 88.3885Z"
        fill="white"
      />
      <path
        d="M79.4646 66.3566C78.6696 67.2232 78.1926 67.6171 77.0796 67.6171C75.9666 67.6171 75.5692 67.1444 74.6947 66.3566C73.8997 65.4899 72.8662 64.4658 71.0377 64.387C74.0587 59.5812 76.3641 56.1935 76.3641 53.3573C76.4436 50.4423 73.7407 48 70.7197 48C67.6988 48 64.9959 50.4423 64.9959 53.3573C64.9959 56.1935 67.3013 59.5812 70.3223 64.387C68.4938 64.4658 67.4603 65.4899 66.6653 66.3566C65.8703 67.2232 65.3934 67.6171 64.2804 67.6171C63.1674 67.6171 62.8494 67.2232 61.9749 66.3566C61.1799 65.4899 60.1465 64.4658 58.2385 64.387C58.159 64.387 58 64.5445 58 64.6233V66.4353C58 66.5929 58.0795 66.6717 58.2385 66.6717C59.113 66.7505 59.59 67.1444 60.3055 67.9322C61.1799 68.7988 62.2134 69.9018 64.2804 69.9018C66.3473 69.9018 67.4603 68.7988 68.2553 67.9322C69.0503 67.0656 69.5273 66.6717 70.6403 66.6717C71.7532 66.6717 72.1507 67.1444 73.0252 67.9322C73.8997 68.7988 74.9332 69.9018 77.0001 69.9018C79.0671 69.9018 80.1801 68.7988 81.0545 67.9322C81.77 67.1444 82.247 66.7505 83.1215 66.6717C83.2805 66.6717 83.36 66.5929 83.36 66.4353V64.6233C83.36 64.4658 83.201 64.387 83.1215 64.387C81.293 64.4658 80.2596 65.5687 79.4646 66.3566ZM70.7197 50.2847C72.5482 50.2847 74.1382 51.7028 74.1382 53.3573C74.1382 55.0905 72.7072 57.5328 70.7197 60.6841C68.7323 57.6116 67.3013 55.0905 67.3013 53.3573C67.3013 51.7816 68.9708 50.2847 70.7197 50.2847Z"
        fill={fill}
      />
      <path
        d="M79.3975 73.113C78.605 74.0187 78.1295 74.4304 77.02 74.4304C75.9105 74.4304 75.5142 73.9364 74.6425 73.113C73.7708 72.2073 72.7405 71.0546 70.68 71.0546C68.6195 71.0546 67.51 72.2073 66.7175 73.113C65.925 74.0187 65.4495 74.4304 64.34 74.4304C63.2305 74.4304 62.8342 73.9364 61.9625 73.113C61.17 72.2073 60.1398 71.1369 58.2377 71.0546C58.0792 71.0546 58 71.1369 58 71.3016V73.1953C58 73.36 58.0792 73.4424 58.2377 73.4424C59.1095 73.5247 59.585 73.9364 60.2983 74.7598C61.17 75.6655 62.2795 76.8182 64.34 76.8182C66.4005 76.8182 67.51 75.6655 68.3025 74.7598C69.095 73.854 69.5705 73.4424 70.68 73.4424C71.7895 73.4424 72.1858 73.9364 73.0575 74.7598C73.9293 75.6655 74.9595 76.8182 77.02 76.8182C79.0805 76.8182 80.19 75.6655 81.0618 74.7598C81.775 73.9364 82.2505 73.5247 83.1223 73.4424C83.2808 73.4424 83.36 73.36 83.36 73.1953V71.3016C83.36 71.1369 83.2015 71.0546 83.1223 71.0546C81.2203 71.1369 80.19 72.2073 79.3975 73.113Z"
        fill={fill}
      />
    </>
  );
  if (hasSurveyData) {
    fill = '#00CC00';
    icon = (
      <>
        <path
          d="M71.0187 88.3885C84.614 88.3885 95.6352 77.4115 95.6352 63.8706C95.6352 50.3298 84.614 39.3528 71.0187 39.3528C57.4235 39.3528 46.4023 50.3298 46.4023 63.8706C46.4023 77.4115 57.4235 88.3885 71.0187 88.3885Z"
          fill="white"
        />
        <path
          d="M63.1004 66.8766C61.4651 67.3751 56.301 64.6444 56.0428 63.3224C55.9352 62.6289 56.0643 59.7248 56.0643 59.7248L63.1219 60.1799V66.855L63.1004 66.8766Z"
          fill="#00CC00"
        />
        <path
          d="M83.2402 68.372C79.1735 65.1428 73.4931 64.6661 68.7809 66.7683C67.0595 67.5268 63.9611 70.1925 62.4118 70.2575C60.2817 70.3442 58.1945 68.1987 56.1289 67.7652V76.7159C58.3236 76.5425 60.8626 73.4217 63.0143 73.5951C64.1762 73.7034 67.5329 76.4992 69.2973 77.171C70.6098 77.6695 71.5781 77.8429 72.9767 77.9512C73.8804 78.0162 75.1283 78.0162 76.0321 77.9512C78.8293 77.7562 81.1961 76.7809 83.3908 75.0255C86.9842 72.1214 86.7905 71.2328 83.2187 68.3937L83.2402 68.372ZM79.6684 73.465C78.4204 73.465 77.4307 72.4464 77.4307 71.2111C77.4307 69.9758 78.442 68.9572 79.6684 68.9572C80.8949 68.9572 81.9062 69.9758 81.9062 71.2111C81.9062 72.4464 80.8949 73.465 79.6684 73.465Z"
          fill="#00CC00"
        />
        <path
          d="M72.5679 54.285L65.7471 54.9785V64.4493C66.6938 63.7341 68.824 62.1304 72.5894 61.892V54.285H72.5679Z"
          fill="#00CC00"
        />
        <path
          d="M82.165 63.344V48H75.1074V61.7836C76.0111 61.7836 78.2704 61.957 82.165 63.3657V63.344Z"
          fill="#00CC00"
        />
      </>
    );
  }
  if (lunkerPotential) {
    fill = '#8800FF';
    icon = (
      <>
        <path
          d="M71.0187 88.3885C84.614 88.3885 95.6352 77.4115 95.6352 63.8706C95.6352 50.3298 84.614 39.3528 71.0187 39.3528C57.4235 39.3528 46.4023 50.3298 46.4023 63.8706C46.4023 77.4115 57.4235 88.3885 71.0187 88.3885Z"
          fill="white"
        />
        <path
          d="M78.367 59.814L75.511 61.6687L72.7864 56.9745C72.4746 57.3192 72.015 57.5161 71.539 57.5325C71.1615 57.5325 70.8004 57.4176 70.505 57.1879L67.9445 61.6359L65.2363 59.8304C64.9901 60.4869 64.35 60.9137 63.6278 60.9301C63.4472 60.9301 63.2667 60.8973 63.1025 60.848L63.3159 70.1216C63.3159 70.4827 63.6278 70.7617 63.9889 70.7617H79.598C79.9755 70.7781 80.2709 70.4991 80.2709 70.138L80.4843 60.7496C80.3038 60.8152 80.1068 60.848 79.9262 60.848C79.2369 60.848 78.6296 60.4377 78.367 59.8304V59.814ZM78.8101 69.3009H73.9025L78.8101 64.6559V69.3009Z"
          fill="#8800FF"
        />
        <path
          d="M64.5957 56.9745C64.5957 55.7599 63.5617 54.7587 62.2979 54.7587C61.034 54.7587 60 55.7599 60 56.9745C60 58.1891 61.034 59.1903 62.2979 59.1903C63.5617 59.1903 64.5957 58.1891 64.5957 56.9745Z"
          fill="#8800FF"
        />
        <path
          d="M71.6045 55.4316C72.8683 55.4316 73.9024 54.4304 73.9024 53.2158C73.9024 52.0012 72.8683 51 71.6045 51C70.3407 51 69.3066 52.0012 69.3066 53.2158C69.3066 54.4304 70.3407 55.4316 71.6045 55.4316Z"
          fill="#8800FF"
        />
        <path
          d="M81.1074 54.7587C79.8436 54.7587 78.8096 55.7599 78.8096 56.9745C78.8096 58.1891 79.8436 59.1903 81.1074 59.1903C82.3713 59.1903 83.4053 58.1891 83.4053 56.9745C83.4053 55.7599 82.3713 54.7587 81.1074 54.7587Z"
          fill="#8800FF"
        />
        <path
          d="M78.99 72.5015H64.5627C63.8647 72.5015 63.2988 73.0674 63.2988 73.7654C63.2988 74.4633 63.8647 75.0292 64.5627 75.0292H78.99C79.688 75.0292 80.2538 74.4633 80.2538 73.7654C80.2538 73.0674 79.688 72.5015 78.99 72.5015Z"
          fill="#8800FF"
        />
      </>
    );
  }
  if (favorite) {
    fill = '#FF8022';
    icon = (
      <>
        <path
          d="M71.0187 88.3885C84.614 88.3885 95.6352 77.4115 95.6352 63.8706C95.6352 50.3298 84.614 39.3528 71.0187 39.3528C57.4235 39.3528 46.4023 50.3298 46.4023 63.8706C46.4023 77.4115 57.4235 88.3885 71.0187 88.3885Z"
          fill="white"
        />
        <path
          d="M72.3371 53.8799L74.0216 57.7681C74.4427 58.7402 75.3691 59.4106 76.4472 59.5111L80.6752 59.9134C81.9554 60.0307 82.4607 61.6061 81.5006 62.4608L78.3169 65.2597C77.5084 65.9636 77.1547 67.053 77.3905 68.0921L78.3169 72.215C78.6033 73.4552 77.2557 74.4272 76.144 73.7904L72.4887 71.6284C71.5622 71.0921 70.4168 71.0921 69.5072 71.6284L65.8519 73.7904C64.757 74.444 63.4094 73.4719 63.6789 72.215L64.6054 68.0921C64.8412 67.053 64.4875 65.9636 63.6789 65.2597L60.4953 62.4608C59.5351 61.6229 60.0573 60.0474 61.3207 59.9134L65.5487 59.5111C66.6099 59.4106 67.5364 58.7402 67.9743 57.7681L69.6588 53.8799C70.1641 52.7067 71.8317 52.7067 72.3371 53.8799Z"
          fill={fill}
        />
      </>
    );
  }

  return (
    <div className={classNames('relative', className)} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="139"
        height="139"
        viewBox="0 0 139 139"
        fill="none"
      >
        <g filter="url(#filter0_d_379_19641)">
          <circle cx="69.5" cy="65.5" r="65.5" fill="#061622" fill-opacity="0.44" />
        </g>
        <g filter="url(#filter1_d_379_19641)">
          <circle cx="69.5" cy="64.5" r="48.5" fill="#061622" fill-opacity="0.69" />
          <path
            d="M108 63.8708C108 92.9318 79.124 102.093 71.7353 127.437C71.5091 128.225 70.4536 128.225 70.2274 127.437C61.934 99.8028 28.6095 89.9656 34.7542 55.6106C36.6767 44.7596 43.8769 35.373 53.9798 30.7924C81.3858 18.402 108 38.0388 108 63.8333V63.8708Z"
            fill={fill}
            stroke="#061622"
            stroke-opacity="0.16"
            stroke-width="2"
          />
          {icon}
        </g>
        <defs>
          <filter
            id="filter0_d_379_19641"
            x="0"
            y="0"
            width="139"
            height="139"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_379_19641" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_379_19641"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_379_19641"
            x="17"
            y="16"
            width="105"
            height="121.028"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_379_19641" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_379_19641"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

PinHighActivitySelected.width = 139;
PinHighActivitySelected.height = 139;
